import React from "react";
import Layout from "app/layout/Layout";
import MainMenu from "app/MainMenu";
import Footer from "app/Footer";
import Page from "app/Page";
import Helmet from "react-helmet";
import { withConfig } from "app/config/hocs";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { Header } from "../utils";

let Content = ({ imprint, fetchConfig }) => {
  if (!imprint) fetchConfig();

  return (
    <Page className="pt-ui-text-large pt-running-text">
      <Helmet title="Imprint" />
      <Header>
        <FormattedMessage id="app.footer.imprint" defaultMessage="Imprint" />
      </Header>
      <div
        className="pt-running-text"
        dangerouslySetInnerHTML={{ __html: imprint }}
      />
    </Page>
  );
};

Content = withConfig(Content);

export default () => {
  return (
    <Layout navbar={<MainMenu />} main={<Content />} footer={<Footer />} />
  );
};



// WEBPACK FOOTER //
// ./src/app/imprint/index.js